@if (action() == 'query') {
  <div class="container">
    <h4 class="mb-2 mt-4">Query Number Assigned</h4>
    <form [formGroup]="checkNumberAssigned" (ngSubmit)="onSubmitCheck()">
      <div class="form-outline">
      </div>
      <div class="form-outline">
        <div class="col-md-6">
          <select class="form-select form-control" formControlName="property" aria-label="Property selection" [ngClass]="{ 'is-invalid': submitQuery() && fq.property.errors }">
            <option selected>Choose Property</option>
            @for (property of proplist(); track property) {
              <option [value]="property.id">{{property.name}}</option>
            }
          </select>
          <label class="form-label" for="configId">Property</label>
          @if (submitQuery() && fq.property.errors) {
            <div class="invalid-feedback d-block mb-2">
              @if (fq.property.errors.required) {
                <div>Please select a property</div>
              }
            </div>
          }
        </div>
        <div class="col-md-6">
          <div class="form-outline">
            <select class="form-select form-control"  formControlName="configId" aria-label="Device configuration" [ngClass]="{ 'is-invalid': submitQuery() && fq.configId.errors }">
              @for (config of deviceConfigs(); track config) {
                <option [value]="config.id">{{config.label}}-{{config.phoneNumber}}</option>
              }
            </select>
            <label class="form-label" for="configId">Sim Assignment</label>
            @if (submitQuery() && fq.configId.errors) {
              <div class="invalid-feedback d-block mb-2">
                @if (fq.configId.errors.required) {
                  <div>Please select a sim device</div>
                }
              </div>
            }
          </div>
        </div>
      </div>
      <div class="form-outline">
        <div class="col-md-3">
          <input type="number" class="form-control" formControlName="sequenceNumber" placeholder="1 - 200" [ngClass]="{ 'is-invalid': submitQuery() && fq.sequenceNumber.errors }">
          <label class="form-label" for="sequenceNumber">Number Position</label>
          @if (submitQuery() && fq.sequenceNumber.errors) {
            <div class="invalid-feedback d-block mb-2">
              @if (fq.sequenceNumber.errors.required) {
                <div>Phone number position is required</div>
              }
            </div>
          }
        </div>
      </div>
      <button type="submit" class="btn btn-primary btn-block mb-2">Query Slot <fa-icon class="ml-2" [icon]="faPaperPlane"></fa-icon></button>
    </form>
  </div>
}

@if (action() == 'add') {
  <div class="container">
    <h4 class="mb-2 mt-4">Add Phone Number</h4>
    <form [formGroup]="addPhoneNumberForm" (ngSubmit)="onSubmit()">
      <div class="row mb-2">
        <div class="col-md-6">
          <div class="form-outline">
            <input type="text" id="firstName" formControlName="firstName" class="form-control" placeholder="e.g John" [ngClass]="{ 'is-invalid': submitAdd() && fi.firstName.errors, 'is-valid': fi.firstName.valid && fi.firstName.touched }"/>
            <label class="form-label" for="firstName">First name</label>
            @if (submitAdd() && fi.firstName.errors) {
              <div class="invalid-feedback mb-2">
                @if (fi.firstName.errors.required) {
                  <div>First name is required</div>
                }
              </div>
            }
            @if (fi.firstName && fi.firstName.errors?.pattern) {
              <div class="invalid-feedback mb-2">
                First name should have 2 or more letters
              </div>
            }
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-outline">
            <input type="text" id="lastName" formControlName="lastName" class="form-control" placeholder="e.g Brown"  [ngClass]="{ 'is-invalid': submitAdd() && fi.lastName.errors, 'is-valid': fi.lastName.valid && fi.lastName.touched }"/>
            <label class="form-label" for="lastName">Last name</label>
            @if (submitAdd() && fi.lastName.errors) {
              <div class="invalid-feedback mb-2">
                @if (fi.lastName.errors.required) {
                  <div>Last name is required</div>
                }
              </div>
            }
            @if (fi.lastName && fi.lastName.errors?.pattern) {
              <div class="invalid-feedback mb-2">
                Last name should have 2 or more letters
              </div>
            }
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-3">
          <div class="form-outline">
            <input type="text" id="phoneNumber" formControlName="phoneNumber" class="form-control" placeholder="e.g 8765550000" [ngClass]="{ 'is-invalid': submitAdd() && fi.phoneNumber.errors, 'is-valid': fi.phoneNumber.valid && fi.phoneNumber.touched }" />
            <label class="form-label" for="phoneNumber">Phone Number</label>
            @if (submitAdd() && fi.phoneNumber.errors) {
              <div class="invalid-feedback mb-2">
                @if (fi.phoneNumber.errors.required) {
                  <div>Phone number is required</div>
                }
              </div>
            }
            @if (fi.phoneNumber && fi.phoneNumber.errors?.pattern) {
              <div class="invalid-feedback mb-2">
                10 digit Phone number, without space or dash
              </div>
            }
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-outline">
            <select class="form-select form-control" formControlName="numberType" aria-label="Default select example">
              <option selected>Type of Number</option>
              <option value="Mobile">Mobile</option>
              <option value="LandLine">Landline</option>
            </select>
            <label class="form-label" for="numberType">Number Type</label>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-outline">
            <select class="form-select form-control"  formControlName="network" aria-label="Default select example">
              <option selected>Choose Network</option>
              @for (network of networks(); track network) {
                <option [value]="network.id">{{network.networkName}}</option>
              }
            </select>
            <label class="form-label" for="network">Network</label>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-outline">
            <select class="form-select form-control"  formControlName="configId" aria-label="Default select example">
              @for (config of deviceConfigs(); track config) {
                <option [value]="config.id">{{config.label}}-{{config.phoneNumber}}</option>
              }
            </select>
            <label class="form-label" for="configId">Sim Assignment</label>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-3">
          <div class="form-outline">
            <input type="text" id="apartmentNumber"  formControlName="apartmentNumber" class="form-control" placeholder="e.g 25"/>
            <label class="form-label" for="apartmentNumber">Apartment/Lot Number</label>
          </div>
        </div>
        <div class="col">
          <div class="form-outline">
            <input type="text" id="lname" formControlName="address" class="form-control" placeholder="e.g 1 Park Close, Kingston"/>
            <label class="form-label" for="address">Address</label>
          </div>
        </div>
      </div>
      <!-- Submit button -->
      <button type="submit" class="btn btn-primary btn-block mb-2">Submit Number <fa-icon class="ml-2" [icon]="faPaperPlane"></fa-icon></button>
    </form>
  </div>
}

@if (action() == 'update') {
  <div class="container">
    <h4 class="mb-2 mt-4">Update Phone Information</h4>
    <form [formGroup]="updatePhoneNumberForm" (ngSubmit)="onUpdate()">
      <!-- 2 column grid layout with text inputs for the first and last names -->
      <div class="row mb-2">
        <div class="col-md-6">
          <div class="form-outline">
            <input type="text" id="firstName" formControlName="firstName" class="form-control" placeholder="e.g John" [ngClass]="{ 'is-invalid': submitUpdate() && fe.firstName.errors, 'is-valid': fe.firstName.valid && fe.firstName.touched }"/>
            <label class="form-label" for="firstName">First name</label>
            @if (submitUpdate() && fe.firstName.errors) {
              <div class="invalid-feedback mb-2">
                @if (fe.firstName.errors.required) {
                  <div>First name is required</div>
                }
              </div>
            }
            @if (fe.firstName && fe.firstName.errors?.pattern) {
              <div class="invalid-feedback mb-2">
                First name should have 2 or more letters
              </div>
            }
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-outline">
            <input type="text" id="lastName" formControlName="lastName" class="form-control" placeholder="e.g Brown" [ngClass]="{ 'is-invalid': submitUpdate() && fe.lastName.errors, 'is-valid': fe.lastName.valid && fe.lastName.touched }" />
            <label class="form-label" for="lastName">Last name</label>
            @if (submitUpdate() && fe.lastName.errors) {
              <div class="invalid-feedback mb-2">
                @if (fe.lastName.errors.required) {
                  <div>Last name is required</div>
                }
              </div>
            }
            @if (fe.lastName && fe.lastName.errors?.pattern) {
              <div class="invalid-feedback mb-2">
                Last name should have 2 or more letters
              </div>
            }
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-4">
          <div class="form-outline">
            <input type="text" id="phoneNumber" formControlName="phoneNumber" class="form-control" placeholder="e.g 8765550000" pattern="^\d{10}$" [ngClass]="{ 'is-invalid': submitUpdate() && fe.phoneNumber.errors, 'is-valid': fe.phoneNumber.valid && fe.phoneNumber.touched }"  />
            <label class="form-label" for="phoneNumber">Phone Number</label>
            @if (submitUpdate() && fe.phoneNumber.errors) {
              <div class="invalid-feedback mb-2">
                @if (fe.phoneNumber.errors.required) {
                  <div>Phone number is required</div>
                }
              </div>
            }
            @if (fe.phoneNumber && fe.phoneNumber.errors?.pattern) {
              <div class="invalid-feedback mb-2">
                10 digit Phone number, without space or dash
              </div>
            }
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-outline">
            <select class="form-select form-control" formControlName="numberType" aria-label="Default select example">
              <option selected>Type of Number</option>
              <option value="Mobile">Mobile</option>
              <option value="LandLine">Landline</option>
            </select>
            <label class="form-label" for="numberType">Number Type</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-outline">
            <select class="form-select form-control"  formControlName="network" aria-label="Default select example">
              <option selected>Choose Network</option>
              @for (network of networks(); track network) {
                <option [value]="network.id">{{network.networkName}}</option>
              }
            </select>
            <label class="form-label" for="network">Network</label>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-3">
          <div class="form-outline">
            <select class="form-select form-control"  formControlName="configId" aria-label="Default select example">
              @for (config of deviceConfigs(); track config) {
                <option [value]="config.id">{{config.label}}-{{config.phoneNumber}}</option>
              }
            </select>
            <label class="form-label" for="configId">Sim Assigned</label>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-outline">
            <select class="form-select form-control"  formControlName="sequenceNumber" aria-label="Default select example">
              @for (seq of sequenceNumbers; track seq) {
                <option [value]="seq">Position-{{seq}}</option>
              }
            </select>
            <label class="form-label" for="sequenceNumber">Position Assigned</label>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-3">
          <div class="form-outline">
            <input type="text" id="apartmentNumber"  formControlName="apartmentNumber" class="form-control" placeholder="e.g 25"/>
            <label class="form-label" for="apartmentNumber">Apartment/Lot Number</label>
          </div>
        </div>
        <div class="col">
          <div class="form-outline">
            <input type="text" id="lname" formControlName="address" class="form-control" placeholder="e.g 1 Park Close, Kingston"/>
            <label class="form-label" for="address">Address</label>
          </div>
        </div>
      </div>
      <!-- Submit button -->
      <button type="submit" class="btn btn-primary btn-block mb-2">Update Number <fa-icon class="ml-2" [icon]="faPaperPlane"></fa-icon></button>
    </form>
  </div>
}

@if (action() == 'list' || action() == null) {
  <div class="container mt-2">
    <div class="row">
      <div class="form-group has-search col-md-8">
        <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
        <input type="text" name="search" [ngModel]="searchNumbers()" (ngModelChange)="searchNumbers.set($event)" class="form-control" placeholder="Search by name, phone" autocomplete="off">
      </div>
      <div class="col-md-4 mt-2">
        <button (click)="addNumber()" class="btn btn-success mb-2">Add Number <fa-icon [icon]="faPlusCircle"></fa-icon></button>
        <button (click)="queryNumber()" class="btn btn-info mx-2 mb-2">Query Number <fa-icon [icon]="faSearch"></fa-icon></button>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-sm divth">
          Name
        </div>
        <div class="col-sm divth">
          Apt/LotNumber
        </div>
        <div class="col-sm divth">
          Phone
        </div>
        <div class="col-sm divth">
          Approved
        </div>
        <div class="col-sm divth">
          Action(s)
        </div>
      </div>
    </div>
    @for (number of numbers() | filter: searchNumbers() | paginate: { itemsPerPage: 25, currentPage: p() } ; track number) {
      <div class="col-md-12">
        <div class="row">
          <div class="col-sm divtd">
            {{number.firstName}} {{number.lastName}}
          </div>
          <div class="col-sm divtd">
            {{number.apartmentNumber}}
          </div>
          <div class="col-sm divtd">
            {{number.phoneNumber}}
          </div>
          <div class="col-sm divtd" [ngClass]="{'text-success': number.status,'text-danger': !number.status}">
            {{number.status}} @if (number.status) {
            <fa-icon class="ml-2" [icon]="faCheckCircle"></fa-icon>
            } @if (!number.status) {
            <fa-icon class="ml-2" [icon]="faTimesCircle"></fa-icon>
          }
        </div>
        <div class="col-sm divtd">
          <td>
            <button (click)="enableNumber(number.id, number.phoneNumber, number.configId, number.sequenceNumber)" class="btn btn-primary acbtn">@if (help() && number.status) {
              <span class="mr-2">Re-Activate</span>
              }@if (help() && !number.status) {
              <span class="mr-2">Activate</span>
              } <fa-icon [icon]="faCheckCircle"></fa-icon></button>
              @if (number.status) {
                <button (click)="disableNumber(number.id, number.phoneNumber, number.configId, number.sequenceNumber)" class="btn btn-warning acbtn">@if (help()) {
                  <span class="mr-2">Disable</span>
                  } <fa-icon [icon]="faBan"></fa-icon></button>
                }
                <button (click)="updateNumber(number.id)" class="btn btn-info acbtn">@if (help()) {
                  <span class="mr-2">Update</span>
                  } <fa-icon [icon]="faPencilAlt"></fa-icon></button>
                  <button (click)="notifyPerson(number.phoneNumber, number.configId,'SMS')" class="btn btn-success acbtn">@if (help()) {
                    <span class="mr-2">SMS</span>
                    } <fa-icon [icon]="faSms"></fa-icon></button>
                    <button (click)="notifyPerson(number.phoneNumber, number.configId, 'Whatsapp')" class="btn btn-success acbtn">@if (help()) {
                      <span class="mr-2">Whatsapp</span>
                      } <fa-icon [icon]="faWhatsapp"></fa-icon></button>
                      <button class="acbtn btn btn-primary mb-1" (click)="openDiv(number.id)">@if (!number.opened && help() && !loadDetail()[number.id]) {
                        <span class="mr-2">View</span>
                        }@if (number.opened && help()) {
                        <span class="mr-2">Hide</span>
                        }@if (!number.opened && !loadDetail()[number.id]) {
                        <fa-icon [icon]="faEye"></fa-icon>
                        }@if (number.opened) {
                        <fa-icon [icon]="faEyeSlash"></fa-icon>
                        } @if (help() && loadDetail()[number.id]) {
                        <span>Loading..</span>
                        }@if (loadDetail()[number.id]) {
                        <fa-icon [icon]="faSpinner"></fa-icon>
                      }</button>
                      <button class="actbtn btn btn-primary mb-1" (click)="onDelete(number.id, number.phoneNumber, number.configId, number.sequenceNumber, number.status)" class="btn btn-danger acbtn">@if (help()) {
                        <span>Delete</span>
                        } <fa-icon [icon]="faTimesCircle"></fa-icon></button>
                        <button (click)="toggleHelp()" class="acbtn btn btn-info">@if (help()) {
                          <span class="mr-2">Help</span>
                          } @if (!help()) {
                          <fa-icon [icon]="faQuestionCircle"></fa-icon>
                          } @if (help()) {
                          <fa-icon [icon]="faEyeSlash"></fa-icon>
                        }</button>
                      </td>
                    </div>
                  </div>
                  @if (number.opened) {
                    <div class="row divdetail">
                      <div class="form-group col-sm-4">
                        <label for="">First Name</label>
                        <div class="input-group mb-2 ">
                          <div class="input-group-prepend">
                            <div class="input-group-text"><fa-icon [icon]="faUser"></fa-icon></div>
                          </div>
                          <input [disabled]="true" type="text" [value]="numberDetail()?.firstName" class="form-control py-0" name="firstName" id="firstName"   >
                        </div>
                      </div>
                      <div class="form-group col-sm-4">
                        <label for="">Last Name</label>
                        <div class="input-group mb-2 ">
                          <div class="input-group-prepend">
                            <div class="input-group-text"><fa-icon [icon]="faMapMarkedAlt"></fa-icon></div>
                          </div>
                          <input [disabled]="true" type="text" [value]="numberDetail()?.lastName" class="form-control py-0" name="address" id="address"   >
                        </div>
                      </div>
                      <div class="form-group col-sm-4" >
                        <label for="">Phone Number</label>
                        <div class="input-group mb-2 ">
                          <div class="input-group-prepend">
                            <div class="input-group-text"><fa-icon [icon]="faMapSigns"></fa-icon></div>
                          </div>
                          <input [disabled]="true" type="text" [value]="numberDetail()?.phoneNumber" class="form-control py-0" name="blockname" id="blockname"   >
                        </div>
                      </div>
                      <div class="form-group col-sm-4" >
                        <label for="">Apartment/Lot Number</label>
                        <div class="input-group mb-2 ">
                          <div class="input-group-prepend">
                            <div class="input-group-text"><fa-icon [icon]="faMapPin"></fa-icon></div>
                          </div>
                          <input [disabled]="true" type="text" [value]="numberDetail()?.apartmentNumber" class="form-control py-0" name="apartmentNumber" id="apartmentNumber" >
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              <pagination-controls (pageChange)="p.set($event)"></pagination-controls>
            </div>
          }

          <!-- <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">First</th>
              <th scope="col">Last</th>
              <th scope="col">Apt/LotNumber</th>
              <th scope="col">Phone</th>
              <th scope="col">Action(s)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let number of numbers | filter: searchNumbers">
              <th scope="row">{{number.id}}</th>
              <td>{{number.firstName}}</td>
              <td>{{number.lastName}}</td>
              <td>{{number.apartmentNumber}}</td>
              <td>{{number.phoneNumber}}</td>
              <td>
                <button (click)="enableNumber(number.phoneNumber, number.configId, number.sequenceNumber)" class="btn btn-primary acbtn">Activate <fa-icon [icon]="faCheckCircle"></fa-icon></button>
                <button (click)="disableNumber(number.phoneNumber, number.configId, number.sequenceNumber)" class="btn btn-danger acbtn">Disable <fa-icon [icon]="faBan"></fa-icon></button>
                <button (click)="editNumber()" class="btn btn-info acbtn">Update <fa-icon [icon]="faPencilAlt"></fa-icon></button>

                <a class="btn btn-danger " href="sms://+18762900603/?body=6666A001#8763706122">Disable</a>
                <a class="btn btn-info" href="sms://+8762880596/?body=6666">Update</a>
              </td>

            </tr>

          </tbody>
        </table> -->
